module.exports = __webpack_public_path__ + "img/69d6bc4.jpg";